import { ICellRendererParams } from 'ag-grid-community'
import { MessageSquareIcon } from 'lucide-react'

import { SmartQuestionStatus } from '@/gen/inventory/v1/control_service_pb'

import { smartQuestionStatusLabel } from '@/const/label'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'
import { smartQuestionStatusToIcon } from '@/components/shared/icons/smart-question-status'

export const ControlEvidenceRequestCell = ({ data }: ICellRendererParams<ControlRow>) => {
  if (!data) return null

  const { smartQuestion } = data

  return (
    <div className='flex size-full items-center'>
      <div className='flex items-center gap-4'>
        <Badge
          variant={
            smartQuestion?.status === SmartQuestionStatus.AWAITING_REVIEW ? 'warning' : 'neutral'
          }
          textCase='title'
        >
          <TextWithIcon
            text={
              smartQuestionStatusLabel[smartQuestion?.status || SmartQuestionStatus.UNSPECIFIED]
            }
            icon={
              smartQuestionStatusToIcon[smartQuestion?.status || SmartQuestionStatus.UNSPECIFIED]
            }
          />
        </Badge>
        {!!smartQuestion?.commentCount && (
          <TextWithIcon text={smartQuestion.commentCount} icon={<MessageSquareIcon size={14} />} />
        )}
      </div>
    </div>
  )
}
